"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Icone = require("./Icone");

var _Icone2 = _interopRequireDefault(_Icone);

var _reactRouter = require("react-router");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

require("../../assets/css/components/elements/LinkAction.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkAction = function (_React$Component) {
    _inherits(LinkAction, _React$Component);

    function LinkAction(props) {
        _classCallCheck(this, LinkAction);

        var _this = _possibleConstructorReturn(this, (LinkAction.__proto__ || Object.getPrototypeOf(LinkAction)).call(this, props));

        _this.getStyle = function (tipo, color) {
            var estilo = void 0;

            if (tipo === 'icon') estilo = "mdl-button--fab mdl-button--mini-fab mdl-button--colored ";else if (tipo === 'flat') estilo = "mdl-button--primary ";else if (tipo === 'table') estilo = "";else estilo = "mdl-button--raised ";

            return "mdl-button mdl-js-button " + (estilo || '') + (color || '') + " " + (_this.props.className || '');
        };

        _this.setActive = function () {
            var element = document.getElementById(_this.state.id);
            var rect = element.getBoundingClientRect();
            var top = rect.top + 25;
            var left = rect.left;
            _this.setState({ top: top, left: left });

            // element.classList.add('is-active')
        };

        _this.removeActive = function () {
            var element = document.getElementById(_this.state.id);
            element.classList.remove('is-active');
        };

        _this.getLink = function (style) {
            return _this.props.open ? _react2.default.createElement(
                "a",
                { href: _this.props.open, target: _this.props.target || "_blank", "aria-label": _this.props.tooltip || "", className: "link-option mdl-button mdl-js-button " + style },
                _react2.default.createElement(
                    "div",
                    { className: "material-icons" },
                    _this.props.icone
                )
            ) : _react2.default.createElement(
                _reactRouter.Link,
                { to: _this.props.to, "aria-label": _this.props.tooltip || "", className: "link-option " + style, onClick: _this.props.onClick },
                _react2.default.createElement(
                    "div",
                    { className: "material-icons" },
                    _this.props.icone
                )
            );
        };

        _this.state = {
            top: '',
            left: '',
            id: Math.random()
        };
        return _this;
    }

    _createClass(LinkAction, [{
        key: "render",
        value: function render() {
            var style = this.getStyle(this.props.type, this.props.color);
            var tooltipPosition = this.props.tooltipPosition || "top";
            return _react2.default.createElement(
                "div",
                { className: "toolips-area", onMouseOver: this.setActive, id: this.state.id },
                this.getLink(style),
                _react2.default.createElement(
                    "div",
                    { className: "tooltips", style: { top: this.state.top, left: this.state.left } },
                    _react2.default.createElement(
                        "div",
                        { className: "mdl-tooltip mdl-tooltip--" + tooltipPosition, "aria-hidden": "true" },
                        this.props.tooltip
                    )
                )
            );
        }
    }]);

    return LinkAction;
}(_react2.default.Component);

exports.default = LinkAction;


LinkAction.propTypes = {
    to: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    icone: _propTypes2.default.string,
    tooltip: _propTypes2.default.string,
    tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
    type: _propTypes2.default.oneOf(['table', 'raised', 'flat', 'icon']).isRequired,
    color: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/elements/LinkAction.js
// module id = 1110
// module chunks = 0